import React from 'react';
import { Container } from "react-bootstrap";
import unauthorizedImg from "../common/images/unauthorized-page.png";

export default function UnauthorizedPage() {

  return (<div className="unauthorized-page-main">
             <img src={unauthorizedImg} alt='unauthorizedpg-img' />
        </div>);
}